export default function triggerFileDownload({
  fileContent,
  fileName
}: {
  fileContent: Blob | string;
  fileName: string;
}): void {
  // Binary data are not handled the same ways than pure string.
  // That's why there is the isBlob flag
  const isBlob = fileContent instanceof Blob;

  const url = isBlob
    ? window.URL.createObjectURL(fileContent as Blob)
    : encodeURI(fileContent as string);

  // Create temporary anchor
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;

  // Trigger download
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  if (isBlob) {
    window.URL.revokeObjectURL(url);
  }
}
